<template>
  <div>
    <table-list
        ref="table"
        idKey="driverId"
        :listConfig="listConfig"
        :apis="apis"
        :searchConfig="searchConfig"
        :createFrom="fromConfig"
        :btn-config="btnConfig"
        @handleBtn="handleBtn"
        @cellDblclick="cellDblclick"
        :btnConfig="btnConfig | filterBtnsRole($route)"
    />
    <from-list :from="payFrom" :fromConfig="payFromConfig" ref="payFromList" @confirm="confirm"></from-list>
    <detail-list ref="detail" :detailConfig="detailConfig" :detailApi="apis.detail">
      <div style="padding: 0 104px;" slot="box_operation_record" slot-scope="data">
        <el-table
            style="width: 99.9%"
            header-align="center"
            align="center"
            :data="data.from.value">
          <el-table-column
              header-align="center"
              align="center"
              prop="operation"
              label="操作">
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="operationTime"
              label="操作时间">
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="operatorName"
              label="操作人">
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="money"
              label="结算金额">
          </el-table-column>
        </el-table>
      </div>
      <div style="padding: 0 104px;" slot="box_operation_remark" slot-scope="data">
        <el-table style="width: 99.9%" header-align="center" align="center" :data="data.from.value">
          <el-table-column header-align="center" align="center" prop="date" label="时间"></el-table-column>
          <el-table-column header-align="center" align="center" prop="operatorName" label="备注人"></el-table-column>
          <el-table-column header-align="center" align="center" prop="remark" label="备注内容"></el-table-column>
        </el-table>
      </div>
      <div style="padding: 0 104px;" slot="box_operation_jieRecord" slot-scope="data">
        <el-table style="width: 99.9%" header-align="center" align="center" :data="data.from.value">
          <el-table-column header-align="center" align="center" prop="statusJie" label="结算状态">
            <template slot-scope="scope">{{
                scope.row.statusJie === 1 ? '未结算' :
                    scope.row.statusJie === 2 ? '审核中' :
                        scope.row.statusJie === 3 ? '已通过' :
                            scope.row.statusJie === 4 ? '部分结算' :
                                scope.row.statusJie === 5 ? '已结算' : ''
              }}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="jieTime" label="打款时间"></el-table-column>
          <el-table-column header-align="center" align="center" prop="jieType" label="结算类型">
            <template slot-scope="scope">{{
                scope.row.jieType === 1 ? '全部结算' :
                    scope.row.jieType === 2 ? '部分结算' : ''
              }}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="jieMoney" label="结算金额"></el-table-column>
        </el-table>
      </div>
    </detail-list>
  </div>
</template>

<script>
import config from './config/list.config'
import {road, driver} from '@/api/public'
import {pay} from '@/api/oilCard'

export default {
  data() {
    return {
      roadList: [],
      driverList: [],
      searchConfig: [],
      ...config(),
      payFromConfig: [
        {title: '充值时间', value: '', key: 'oilPayTime', type: 'date', span: 12},
        {title: '充值方式', value: '', key: 'oilPayType', type: 'input', span: 12}
      ],
      payFrom: {
        planId: 1
      }
    }
  },
  created() {
    this.createConfig();
  },
  methods: {
    cellDblclick(row) {
      this.$refs.detail.getDtail(row.planId);
    },
    handleBtn(key, list) {
      this[key](list)
    },
    openPayFrom(list) {
      if (list.length !== 1) this.$error('请选择一项充值')
      this.$refs.payFromList.open(null, {planId: list[0].planId});
    },
    confirm(_params) {
      const params = this.getParams();
      pay({...params, ..._params}).then(res => {
        this.$refs.payFromList.close();
        this.$refs.table.getList();
      })
    },
    getParams() {
      let _params = {};
      this.payFromConfig.forEach(item => {
        let _key = item.key;
        let _value = item.value;
        if (item.compose) {
          const {key, value} = item.compose();
          _key = key;
          _value = value;
        }
        if (!_value && !item.notRequired) {
          this.$error(`${item.title}为必填项`);
        }
        _params[_key] = _value;
      })

      return _params
    },
    createConfig() {
      Promise.all([road(), driver()]).then(([road, driver]) => {
        this.roadList = road.data.map(item => ({...item, label: item.name, value: item.roadId}));
        this.driverList = driver.data.map(item => ({...item, label: item.name, value: item.driverId}));
        this.searchConfig = this.createSearch(this.roadList, this.driverList);
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
